module.exports = __webpack_public_path__ + "static/img/iconfont.2ee25d50.svg";